import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import { useThemeContext } from "@/react/providers";
import { Icon } from "@circle-react/components/shared/Icon";
import { supportWidgetPaths } from "@circle-react/helpers/urlHelpers";
import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import { Typography } from "@circle-react-uikit/Typography";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import type { Space, SpaceGroup } from "../types/space";

export const SpaceGroupListItem = ({
  spaceGroup,
}: {
  spaceGroup: SpaceGroup;
}) => {
  const { setCurrentSpaceProperties } = useHelpWidgetContext();
  const history = useHistory();
  const { currentAppearance } = useThemeContext();

  const handleClick = (space: Space) => {
    setCurrentSpaceProperties({
      name: space.name,
      emoji: space.emoji,
      custom_emoji_url: space.custom_emoji_url ?? "",
      custom_emoji_dark_url: space.custom_emoji_dark_url ?? "",
    });
    history.push(supportWidgetPaths.posts(space.id));
  };

  if (isEmpty(spaceGroup.spaces)) return null;

  return (
    <>
      <div className="px-6">
        <Typography.LabelXxs color="text-light">
          {spaceGroup.name}
        </Typography.LabelXxs>
      </div>
      <div className="flex flex-col">
        {spaceGroup.spaces.map(space => (
          <button
            type="button"
            className="hover:bg-tertiary focus:bg-secondary flex cursor-pointer items-center justify-between space-x-6 px-6 py-2 transition-all duration-150 ease-in-out last:mb-4"
            key={space.id}
            onClick={() => handleClick(space)}
          >
            <Typography.LabelSm weight="medium">
              <div className="flex flex-row">
                <EmojiRenderer
                  className="!h-5 !w-auto"
                  emoji={space.emoji}
                  customEmojiUrl={space.custom_emoji_url}
                  customEmojiDarkUrl={space.custom_emoji_dark_url}
                  appearance={currentAppearance}
                />
                <span className="ml-2 break-all">{space.name}</span>
              </div>
            </Typography.LabelSm>
            <Icon type="16-chevron-right" size={16} className="text-default" />
          </button>
        ))}
      </div>
    </>
  );
};
